import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=2b8fd360&scoped=true&lang=pug&"
import script from "./IconCheck.vue?vue&type=script&lang=js&"
export * from "./IconCheck.vue?vue&type=script&lang=js&"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=2b8fd360&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8fd360",
  null
  
)

export default component.exports